module.exports = __webpack_public_path__ + "static/img/1.1275aba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/test/1.jpg
// module id = FHvf
// module chunks = 1